import React, { useEffect } from "react";
import s from "./EventsList.module.scss";
import Header from "../../components/Header/LandingHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import EventItem from "../../components/EventItem/EventItem";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { useDispatch, useSelector } from "react-redux";
import { getEvents } from "../../../../redux/LangingPageSlice";
import PageTitle from "../../components/PageTitle/PageTitle";

const EventsList = () => {
  const { width } = useWindowDimensions();
  const events = useSelector((state) => state.landing.events);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEvents());
  }, [dispatch]);

  return (
    <div>
      {width > 1200 ? (
        <div className={s.header_wrapper}>
          <Header />
        </div>
      ) : (
        <MobileHeader />
      )}
      <PageTitle
        className={s.h2}
        eyebrow="Events"
        title="International events"
      />
      <div className={s.events}>
        {events?.map((event) => (
          <EventItem key={event.id} event={event} />
        ))}
      </div>
      <LandingFooter />
    </div>
  );
};

export default EventsList;
